import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import governance from "../assets/images/governance.jpeg";
import economyDevelopment from "../assets/images/economy-development.jpeg";
import energyPolicy from "../assets/images/energy-policy.jpeg";
import securityGovernance from "../assets/images/security-governance.jpeg";
import annualPriorities from "../assets/images/annual-priorities.jpeg";
import developmentAid from "../assets/images/development-aid.jpeg";

gsap.registerPlugin(ScrollTrigger);

const topicsData = [
  {
    title: "Good Governance",
    description:
      "Ensuring transparency, accountability, and effective public administration across nations.",
    image: governance,
  },
  {
    title: "Security & Governance",
    description:
      "Exploring the critical link between national security and effective governance practices.",
    image: securityGovernance,
  },
  {
    title: "Energy Policy",
    description:
      "Addressing sustainable energy strategies and their role in global governance frameworks.",
    image: energyPolicy,
  },
  {
    title: "Economic Development",
    description:
      "Driving inclusive growth through policy reforms and international cooperation.",
    image: economyDevelopment,
  },
  {
    title: "Development Aid",
    description:
      "Understanding how international assistance can shape policy and long-term impact.",
    image: developmentAid,
  },
  {
    title: "Annual Priorities",
    description:
      "Each year brings a unique focus: innovation, resilience, and sustainable policy making.",
    image: annualPriorities,
  },
];

const CoreTopics = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
    cardsRef.current.forEach((card, i) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.fromTo(
        card,
        {
          autoAlpha: 0,
          scale: 0.8,
        },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.8,
          ease: "power2.out",
          clearProps: "all",
        }
      );
    });
  }, []);

  return (
    <section className="pt-20 text-white font-outfit relative">
      <h3 className="text-[1.3125rem] text-center xxs:text-lg xs:text-lg xxs:mb-[1.5rem] xs:mb-[1.5rem] leading-[1.3125rem] mb-[3rem] uppercase tracking-[0.2em] font-normal text-white">
        Core Topics
      </h3>

      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto">
        {topicsData.map((topic, index) => (
          <div
            key={index}
            ref={(el) => (cardsRef.current[index] = el)}
            className="relative overflow-hidden rounded-2xl shadow-lg group"
          >
            <img
              src={topic.image}
              alt={topic.title}
              className="w-full h-64 object-cover mix-blend-luminosity transform transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 group-hover:bg-opacity-60 transition" />

            <div className="absolute top-4 left-4 backdrop-blur-md bg-white/10 px-4 py-2 rounded-lg">
              <h3 className="text-lg font-semibold text-white tracking-wide">
                {topic.title}
              </h3>
            </div>

            <div className="absolute bottom-0 left-0 right-0 px-6 pb-6 bg-gradient-to-t from-[#08113F] to-transparent">
              <p className="text-sm text-[#b8eae4] leading-relaxed">
                {topic.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CoreTopics;
